import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';

const SfhModalTitle = styled.span`
  font-family: ${variables.family.goldSilverHeaders}, sans-serif;
  font-size: ${pxToRem(20)};
  font-weight: 600;
  line-height: 1.3;
`;

export default SfhModalTitle;
